import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./styles/admin.css";
import "./styles/auth.css";

createApp(App).use(router).mount("#app");
